import { AUSnackBarService } from '@app/notifications/au-snackbar.service';
import {
  Component,
  DestroyRef,
  HostListener,
  inject,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { IAUSnackBarData } from '@app/shared/models/snackbars/au-snackbar-data.model';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'acs-au-error-snack-bar',
  templateUrl: './au-snackbar.component.html',
  standalone: false
})
export class AUSnackBarComponent implements OnInit, OnDestroy {
  public snackbarDataArr: IAUSnackBarData[] = [];
  public isDetailInfoArray = false;
  public isMoreDetailInfoArray = false;
  public showServerErrors = false;

  private durationIntervals: NodeJS.Timeout[] = [];
  private destroyRef = inject(DestroyRef);

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: IAUSnackBarData,
    private auSnackBarService: AUSnackBarService,
    private snackBarRef: MatSnackBarRef<AUSnackBarComponent>
  ) {
    this.processSnackbarData(data);
  }

  @HostListener('window:keyup.esc')
  windowKeyDown(): void {
    this.close();
  }

  ngOnInit(): void {
    this.auSnackBarService.updateSnackbar$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((updateData: IAUSnackBarData) => {
        const foundIndex = this.snackbarDataArr.findIndex((x) => x.id === updateData.id);
        if (foundIndex > -1) {
          this.snackbarDataArr[foundIndex] = updateData;
        } else {
          this.processSnackbarData(updateData);
        }
      });

    this.showServerErrors = this.data.defaultMoreDetailsExpanded;
  }

  ngOnDestroy(): void {
    this.durationIntervals.forEach((x) => clearTimeout(x));
    this.durationIntervals = undefined;
  }

  public close(id?: string): void {
    if (!id) {
      this.snackBarRef.dismiss();
      return;
    }

    this.snackbarDataArr = this.snackbarDataArr.filter((x) => x.id !== id);

    if (this.snackbarDataArr.length === 0) {
      this.snackBarRef.dismiss();
    }
  }

  public displayServerDetails(): void {
    this.showServerErrors = !this.showServerErrors;
  }

  private processSnackbarData(data: IAUSnackBarData): void {
    // if text matches existing text exactly then do not display
    const matchingDataExists = this.snackbarDataArr.some((x) => {
      const detailString = JSON.stringify(x.detailItems);
      const serverDetailString = JSON.stringify(x.moreDetailItems);

      if (
        detailString === JSON.stringify(data.detailItems) &&
        serverDetailString === JSON.stringify(data.moreDetailItems)
      ) {
        return true;
      }
    });

    if (matchingDataExists) {
      return;
    }

    data.initDetailItemsProps();

    if (data.duration) {
      const interval = setTimeout(() => {
        this.close(data.id);
      }, data.duration);

      this.durationIntervals.push(interval);
    }

    this.snackbarDataArr.push(data);
  }
}
